import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { isDisplayable } from "util/misc";
import _ from "lodash";
import {
  getTeamSideFromId,
  getTeamCode,
  getPlayTypeNameById
} from "games/utils";

import { Button } from "react-admin";

const PlayRow = ({ play, game, setPlayId, setShowDialog }) => {
  const handleOpenClick = (playId) => {
    setShowDialog(true);
    setPlayId(playId);
  };

  const getTeamInPossessionDisplay = (play) => {
    const { teamInPossessionId } = play;
    const teamSide = getTeamSideFromId(game, teamInPossessionId);
    return getTeamCode(teamSide, game);
  };

  const getYardLineDisplay = (play) => {
    const { yardLineTeamId, yardLine } = play;
    if (!(yardLineTeamId && isDisplayable(yardLine))) return;
    const teamSide = getTeamSideFromId(game, yardLineTeamId);
    const teamCode = getTeamCode(teamSide, game);
    return `${teamCode} ${yardLine}`;
  };

  const getBallSpotDisplay = (play) => {
    const { ballSpotTeamId, ballSpot } = play;
    if (!(ballSpotTeamId && isDisplayable(ballSpot))) return;
    const teamSide = getTeamSideFromId(game, ballSpotTeamId);
    const teamCode = getTeamCode(teamSide, game);
    return `${teamCode} ${ballSpot}`;
  };

  const players = [
    ..._.get(game, "home.season.players", []),
    ..._.get(game, "away.season.players", [])
  ];

  const playersDisplay = (play) => {
    const { player1Id, player2Id } = play;
    if (!player1Id) return;

    return players
      .filter((player) => player.id === player1Id || player.id === player2Id)
      .map((player) => _.get(player, "person.name"))
      .join(", ");
  };

  const scoringInfo = (play) => {
    const { homePointsGained = null, awayPointsGained = null } = play;
    if (!homePointsGained && !awayPointsGained) return null;
    const pointsGainedSide = homePointsGained ? "home" : "away";
    const teamCode = getTeamCode(pointsGainedSide, game);
    return `${teamCode} +${homePointsGained || awayPointsGained}`;
  };

  const playEditButton = (playId) => {
    return (
      <Button label="Edit" onClick={() => handleOpenClick(playId)}></Button>
    );
  };

  const getLengthOfPlayDisplay = (play) => {
    const { playType, lengthOfPlay } = play;
    const isPenaltyPlay =
      playType === "penaltyOffense" || playType === "penaltyDefense";

    return isPenaltyPlay ? Math.abs(lengthOfPlay) : lengthOfPlay;
  };

  const getDistanceToGoDisplay = (play) => {
    const { distanceToGo } = play;
    return distanceToGo === 100 ? "Goal" : distanceToGo;
  };

  const { playType, down, quarter } = play;

  return (
    <TableRow key={play.id}>
      <TableCell>{quarter}</TableCell>
      <TableCell>{getTeamInPossessionDisplay(play)}</TableCell>
      <TableCell>{down}</TableCell>
      <TableCell>{getDistanceToGoDisplay(play)}</TableCell>
      <TableCell>{getYardLineDisplay(play)}</TableCell>
      <TableCell component="th" scope="row">
        {getPlayTypeNameById(playType)}
      </TableCell>
      <TableCell>{playersDisplay(play)}</TableCell>
      <TableCell>{getLengthOfPlayDisplay(play)}</TableCell>
      <TableCell>{getBallSpotDisplay(play)}</TableCell>
      <TableCell>{scoringInfo(play)}</TableCell>
      <TableCell>{playEditButton(play.id)}</TableCell>
    </TableRow>
  );
};

export default PlayRow;
